var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe01 = function SvgGlobe01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F76B15",
    fillRule: "evenodd",
    d: "M3.055 11H7.05a16.3 16.3 0 0 1 2.676-7.71A9.01 9.01 0 0 0 3.055 11M12 3.55A14.3 14.3 0 0 0 9.058 11h5.884A14.3 14.3 0 0 0 12 3.55M14.942 13A14.3 14.3 0 0 1 12 20.45 14.3 14.3 0 0 1 9.058 13zM7.05 13H3.055a9.01 9.01 0 0 0 6.67 7.71A16.3 16.3 0 0 1 7.05 13m7.224 7.71A16.3 16.3 0 0 0 16.95 13h3.995a9.01 9.01 0 0 1-6.67 7.71m6.67-9.71H16.95a16.3 16.3 0 0 0-2.676-7.71A9.01 9.01 0 0 1 20.945 11M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12",
    clipRule: "evenodd"
  })));
};
export default SvgGlobe01;